import Store from '../storeClass';
import { createSelector, Ref, SessionBoundModel, Selector, OrmState } from 'redux-orm';
import { Campaign } from '../models/redux';
import { CampaignType } from '@copilot/data/responses/interface';

export type CampaignModel = SessionBoundModel<Campaign, {}>;
type CampaignRef = Ref<SessionBoundModel<Campaign, {}>>;
export namespace CampaignSelectors {
    export const getCampaign = (id: string): Selector<any, CampaignRef | undefined> =>
        createSelector(Store.ORM, (session) => session.Campaign.withId(id)?.ref);

    export const getCampaigns = createSelector(Store.ORM, (session) =>
        session.Campaign.all().toRefArray()
    );

    export const getCampaignsWithMembers = createSelector(
        Store.ORM,
        (state: typeof Store.State) => state.entities.CampaignMember,
        (session) => session.Campaign.all().toModelArray()
    );

    export const getCampaignsByOrgId = createSelector(
        Store.ORM,
        (_, organizationId) => organizationId,
        (session, organizationId) => session.Campaign.filter({ organizationId }).toRefArray()
    );

    export const getApprovedCampaigns = createSelector(Store.ORM, (session) =>
        session.Campaign.all().toRefArray()
    );

    /**
     * Select campaigns by campaign types
     * @param {CampaignType[]} type campaign types
     */
    export const getCampaignsByType =
        (types: CampaignType[]) =>
        (state: { entities: OrmState<any> }): CampaignModel[] => {
            const campaigns = Store.ORM.session(state.entities).Campaign;
            const campaignMap = new Set(types);
            return campaigns
                .all()
                .toModelArray()
                .filter((c) => campaignMap.has(c.type));
        };
}
